

import { useState, useEffect } from 'react'
import { PINNED_STANDAARD_VERSIONS, standaardDocumentUrl } from '../../helpers/meetstandaard/standaardVersions'
import adaptMeetstandaardDocument from '../../helpers/meetstandaard/adaptMeetstandaardDocument'
import mergeStandaardCatalogs from '../../helpers/meetstandaard/mergeStandaardCatalogs'

// Module-level cache: the meetstandaard database is static per session and this
// hook is mounted by several components at once (EffectManager, AddEffectFlow,
// NodeEditor) — one shared fetch instead of one per consumer. A failed fetch
// clears the cache so the next mount retries.
let cachedDatabasePromise = null

const fetchDatabase = () => {
    if (!cachedDatabasePromise) {
        cachedDatabasePromise = fetch('https://us-central1-meetstandaard-api.cloudfunctions.net/database')
            .then(res => {
                if (!res.ok) {
                    throw new Error('Network response was not ok');
                }
                return res.json();
            })
            .catch(error => {
                cachedDatabasePromise = null;
                throw error;
            });
    }
    return cachedDatabasePromise;
}

// Versioned standaarden, one immutable document per pinned sector. Same caching
// rule as above; a failure clears the cache so the next mount retries.
let cachedStandaardenPromise = null

const fetchVersionedStandaarden = () => {
    if (!cachedStandaardenPromise) {
        const sectors = Object.entries(PINNED_STANDAARD_VERSIONS)
        cachedStandaardenPromise = Promise.all(
            sectors.map(([sector, version]) =>
                fetch(standaardDocumentUrl(sector, version))
                    .then(res => {
                        if (!res.ok) {
                            throw new Error(`Meetstandaard ${sector} ${version} gaf status ${res.status}`);
                        }
                        return res.json();
                    })
                    .then(adaptMeetstandaardDocument)
            )
        ).catch(error => {
            cachedStandaardenPromise = null;
            throw error;
        });
    }
    return cachedStandaardenPromise;
}

const EffectDatabase = () => {

    const [database, setDatabase] = useState([])

    useEffect(() => {
        let cancelled = false;

        // Both catalogues are fetched together. Promise.all rather than
        // settling separately: a half-loaded picker would silently offer only
        // some of the standaarden, which reads as "that effect doesn't exist".
        Promise.all([fetchDatabase(), fetchVersionedStandaarden()])
        .then(([legacy, standaarden]) => {
            if (cancelled) return;
            setDatabase(mergeStandaardCatalogs(legacy, standaarden));
        })
        .catch(error => {
            if (cancelled) return;
            // eslint-disable-next-line no-console
            console.error('There has been a problem with your fetch operation:', error);
        });

        return () => { cancelled = true; };
    }, [])

    return (
        database
    )


}

export default EffectDatabase
